var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 5.33341H2.66667V6.00008H3.33333V5.33341ZM2.66667 4.66675C2.29847 4.66675 2 4.96521 2 5.33341V6.00008C2 6.36828 2.29847 6.66675 2.66667 6.66675H3.33333C3.70153 6.66675 4 6.36828 4 6.00008V5.33341C4 4.96521 3.70153 4.66675 3.33333 4.66675H2.66667Z",
    fill: "#969BA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00033 5.33341H5.33366V6.00008H6.00033V5.33341ZM5.33366 4.66675C4.96546 4.66675 4.66699 4.96521 4.66699 5.33341V6.00008C4.66699 6.36828 4.96546 6.66675 5.33366 6.66675H6.00033C6.36853 6.66675 6.66699 6.36828 6.66699 6.00008V5.33341C6.66699 4.96521 6.36853 4.66675 6.00033 4.66675H5.33366Z",
    fill: "#969BA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66634 5.33341H7.99967V6.00008H8.66634V5.33341ZM7.99967 4.66675C7.63147 4.66675 7.33301 4.96521 7.33301 5.33341V6.00008C7.33301 6.36828 7.63147 6.66675 7.99967 6.66675H8.66634C9.03454 6.66675 9.33301 6.36828 9.33301 6.00008V5.33341C9.33301 4.96521 9.03454 4.66675 8.66634 4.66675H7.99967Z",
    fill: "#969BA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33333 7.99992H2.66667V8.66659H3.33333V7.99992ZM2.66667 7.33325C2.29847 7.33325 2 7.63172 2 7.99992V8.66659C2 9.03479 2.29847 9.33325 2.66667 9.33325H3.33333C3.70153 9.33325 4 9.03479 4 8.66659V7.99992C4 7.63172 3.70153 7.33325 3.33333 7.33325H2.66667Z",
    fill: "#969BA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00033 7.99992H5.33366V8.66659H6.00033V7.99992ZM5.33366 7.33325C4.96546 7.33325 4.66699 7.63172 4.66699 7.99992V8.66659C4.66699 9.03479 4.96546 9.33325 5.33366 9.33325H6.00033C6.36853 9.33325 6.66699 9.03479 6.66699 8.66659V7.99992C6.66699 7.63172 6.36853 7.33325 6.00033 7.33325H5.33366Z",
    fill: "#969BA4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66634 7.99992H7.99967V8.66659H8.66634V7.99992ZM7.99967 7.33325C7.63147 7.33325 7.33301 7.63172 7.33301 7.99992V8.66659C7.33301 9.03479 7.63147 9.33325 7.99967 9.33325H8.66634C9.03454 9.33325 9.33301 9.03479 9.33301 8.66659V7.99992C9.33301 7.63172 9.03454 7.33325 8.66634 7.33325H7.99967Z",
    fill: "#969BA4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.666667C0.815907 0.666667 0.666667 0.8159 0.666667 1V10C0.666667 10.1841 0.815907 10.3333 1 10.3333H10.3333C10.517 10.3333 10.6667 10.1838 10.6667 9.99927V1.00073C10.6667 0.816167 10.517 0.666667 10.3333 0.666667H9.33333V0H10.3333C10.8861 0 11.3333 0.4489 11.3333 1.00073V9.99927C11.3333 10.5511 10.8861 11 10.3333 11H1C0.447717 11 0 10.5523 0 10V1C0 0.4477 0.447717 0 1 0H2.66667V0.666667H1ZM8 0.666667H4V0H8V0.666667Z",
    fill: "#969BA4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 3.66667H0.666992V3H10.667V3.66667Z",
    fill: "#969BA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.a2a2436e9d91c7ca37d5b4cc0b61db4b.svg";
export { ForwardRef as ReactComponent };